import { connect } from "react-redux";
import App from "../components/App";

export default connect(
  ({
    user: { brand, clienttype },
    wifi: { loaded, updating, updated, eligibleForFreeSim, gbaSim }
  }) => {
    return {
      loaded,
      brand,
      clienttype,
      updating,
      eligibleForFreeSim,
      gbaSim,
      updated
    };
  }
)(App);
